import { render } from "./SurveyImprovementComments.vue?vue&type=template&id=4b3dde60"
import script from "./SurveyImprovementComments.vue?vue&type=script&lang=js"
export * from "./SurveyImprovementComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__